import { render, staticRenderFns } from "./DetailResults.vue?vue&type=template&id=cba4e864&lang=pug&"
import script from "./DetailResults.vue?vue&type=script&lang=js&"
export * from "./DetailResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports